import { ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { api } from '/app/plugins/services';
import { singleFlight } from '/app/utils/single-flight';

// Both fetchers below hit the same endpoint, and the panel can ask for the list
// while the badge is still loading the total.
const load = singleFlight(() => api.sharing.snoozed());

export const useSharing = createSharedComposable(() => {
    const loading = ref(false);
    const totalSnoozed = ref(0);
    const snoozeds = ref([]);

    async function fetchTotalSnoozed() {
        try {
            const { data: response } = await load();
            totalSnoozed.value = response.meta?.total || 0;
        } catch (err) {
            console.log(err);
        }
    }

    async function fetchSnoozed() {
        // No early return while loading: callers await the result, so they get
        // the in-flight call rather than a promise that resolves before it.
        try {
            loading.value = true;
            const { data: response } = await load();
            snoozeds.value = response.data.map(item => ({ ...item, removing: false }));
            totalSnoozed.value = response.meta?.total || 0;
        } catch (err) {
            console.log(err);
        } finally {
            loading.value = false;
        }
    }

    function setSnoozeds(items) {
        snoozeds.value = items.map(item => ({ ...item, removing: false }));
    }

    return { loading, totalSnoozed, snoozeds, fetchTotalSnoozed, fetchSnoozed, setSnoozeds };
});
